<template>
  <div class="with-header">
    <header-view />
    <problem-editor :problem="problem" @cancel="problemEditorCanceled" @created="problemEditorCreated" @updated="problemEditorUpdated" />
    <div class="view-problems">
      <new-problem-view v-for="problem in problems" canedit v-bind:key="problem['.id']" :problem="problem" @editProblem="editProblem" />
    </div>
  </div>
</template>
<script>
import database from '@/api/database.js'
import HeaderView from '@/components/HeaderView.vue'
import NewProblemView from '@/components/NewProblemView.vue'
import ProblemEditor from '@/components/ProblemEditor.vue'

export default {
  name: 'ProblemReporter',
  components: {
    HeaderView, NewProblemView,ProblemEditor
  },
  data () {
    return {
      problem: database.assembleProblem(),
      fields: {},
      newStatus: {},
      problems: [],
      user: undefined
    }
  },
  mounted () {
    database.getCurrentUserAndProfile().then(userAndProfile => {
      this.user = userAndProfile.user
      console.log(this.user)
    })
    database.getFields().then(fields => {
      this.fields = fields
    }),
    database.getProblemsCreatedByUser().then(problems => {
      this.problems = problems
    }).catch(ignored => {})
  },
  methods: {
    getProblem (problemId) {
      database.getProblem(problemId).then(problem => {
        this.problems.push(problem)
      }).catch (ignored => {})
    },
    editProblem (problem) {
      this.problem = JSON.parse(JSON.stringify(problem))
    },
    problemEditorCanceled () {
      this.problem = database.assembleProblem()
    },
    problemEditorCreated (createdProblem) {
      this.problems.push(createdProblem)
      this.problemEditorCanceled()
    },
    problemEditorUpdated (updatedProblem) {
      this.problems.splice(this.problems.findIndex(p => p.id === updatedProblem.id),1,updatedProblem)
      this.problemEditorCanceled()
    },
    saveFieldDefinitions (event) {
      database.saveFieldDefinitions()
    }
  }
}
</script>

<style scoped>
.with-header {
  padding: 60px 0 0 0;
  position: relative;
}
img {
  height: 55px;
  animation: fadein 3s;
}
@keyframes fadein {
  from { opacity: 0; }
  to   { opacity: 1; }
}

.view-problems {
  margin: 13px 25px;
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: auto;
  grid-row-gap: 13px;
  grid-column-gap: 1%;
}

</style>